module.exports = __webpack_public_path__ + "media/vd.30ae2314.mp4";